import React from 'react'
import { useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import { parseStoreAccountPathFromUrl } from '../../../hooks/routeHooks'
import { MpCardMainPage } from './index'
import { MpCardRootRedirect } from './mpCardRootRedirect'

/**
 * Fallback when no explicit route matched. Preserves deep links like /YandexMarket/4.
 */
export const MpCardFallbackRoute =
  observer(() => {
    const {pathname} = useLocation()
    const accountRoute = parseStoreAccountPathFromUrl(pathname)

    if (accountRoute.integration != null && accountRoute.accountId != null) {
      return <MpCardMainPage/>
    }

    return <MpCardRootRedirect/>
  })
